import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen } from 'lucide-react';
import { volumes, lessonGroups } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-cream" data-id="element-265" data-mp="cp0zcd90b28x">
      <div className="max-w-6xl mx-auto" data-id="element-266" data-mp="cnpv6cbnfsha">
        <div className="text-center mb-16" data-id="element-267" data-mp="7po537ft2swb">
          <p className="text-terracotta font-semibold tracking-[0.18em] uppercase text-xs mb-3" data-id="element-268" data-mp="7pxrym5k0jxs">
            The Teaching Library
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-charcoal" data-id="element-269" data-mp="3c3mge6p356ub">
            6 complete volumes of drawing lessons ready to teach
          </h2>
          <p className="text-xl text-terracotta-dark" data-id="element-270" data-mp="3pwc90tz4da0e">
            Organized by skill focus · All levels covered · Nothing to build
            from zero
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-271" data-mp="2xd5igxbnsz26">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-paper rounded-2xl border ${volume.featured ? 'border-terracotta shadow-[0_10px_30px_-18px_rgba(138,74,43,0.45)]' : 'border-warmgray'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-272" data-mp="2sf40ygtvt7st" data-mpi={index}>
              {volume.featured && <div className="absolute top-6 right-[-35px] bg-terracotta-deep text-paper font-bold text-xs py-1 px-10 rotate-45 shadow-sm" data-id="element-273" data-mp="24g5ry923mz2p">
                  MOST USED
                </div>}

              <div className="mb-6 pr-16" data-id="element-274" data-mp="3fv1f6jeta8uv">
                <div className="text-terracotta font-bold text-sm uppercase tracking-wider" data-id="element-275" data-mp="3ftzs1gkitvws">
                  {volume.number}
                </div>
                <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-charcoal" data-id="element-276" data-mp="1brzsfsjspjaw">
                  {volume.title}
                </h3>
              </div>

              <p className="text-charcoal font-medium mb-6 italic border-l-2 border-terracotta/50 pl-4" data-id="element-277" data-mp="1ppelr8d66b85">
                {volume.subtitle}
              </p>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-278" data-mp="x3v8ymcx53r2">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-279" data-mp="t2jea2f6tsc0">
                    <CheckCircle2 size={18} className="text-terracotta shrink-0 mt-0.5" aria-hidden="true" data-id="element-280" data-mp="16swokbfjxj4i" />
                    <span className="text-charcoal-soft text-sm" data-id="element-281" data-mp="ebu0qte9814z">
                      {bullet}
                    </span>
                  </li>)}
              </ul>

              <div className="bg-sand border border-warmgray rounded-xl p-4 mt-auto" data-id="element-282" data-mp="2l0upjv7uc6tz">
                <span className="text-terracotta-deep font-bold block mb-1" data-id="element-283" data-mp="2kyrsir89tdfr">
                  Result:
                </span>
                <p className="text-charcoal-soft text-sm" data-id="element-284" data-mp="2c0g14mzkybm9">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-12 bg-sand border border-warmgray rounded-2xl p-8" data-id="element-285" data-mp="2gz943lh8qk86">
          <div className="flex items-center gap-3 mb-8" data-id="element-286" data-mp="1jb8suwabq7nt">
            <BookOpen size={20} className="text-terracotta" aria-hidden="true" data-id="element-287" data-mp="1j9nxj4g6qkow" />
            <h3 className="text-lg font-bold text-charcoal" data-id="element-288" data-mp="1obda4oj236f3">
              The 150 Ready-to-Teach Lessons, organized
            </h3>
          </div>
          <ol className="grid md:grid-cols-2 gap-x-8 gap-y-5" data-id="element-289" data-mp="23ltilrqtb6qm">
            {lessonGroups.map(group => <li key={group.range} className="border-l-2 border-terracotta/40 pl-4" data-id="element-290" data-mp="1urokqod9gv1l">
                <p className="text-xs font-semibold uppercase tracking-wider text-terracotta-dark" data-id="element-291" data-mp="1ptdc2gypcqky">
                  {group.range}
                </p>
                <p className="font-bold text-charcoal" data-id="element-292" data-mp="2mgi9jahqbgms">{group.title}</p>
                <p className="text-sm text-charcoal-muted" data-id="element-293" data-mp="2ihragxtpdox1">{group.detail}</p>
              </li>)}
          </ol>
        </motion.div>
      </div>
    </section>;
}